export const parseHeader = (header: string): any =>
  header
    .split('\r\n')
    .slice(1)
    .reduce((acc, cur) => ({ ...acc, [cur.split(': ')[0]]: cur.split(': ')[1] }), {})
